<script setup>
import { ref } from "vue"
import { onMounted } from 'vue'
import { $bus } from '../common/events'
</script>

<template>
  <Teleport to="body">
    <div class="fullscreen">
      <slot />
    </div>
  </Teleport>
</template>

<style scoped>
.fullscreen { 
  display: block;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  z-index: 100;
  background: white;
}
</style>
